import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import logger from "lib/log";

import {
  isPaymentInstallmentInBasket,
  isPaymentInBasket,
  isPaymentPendingParentalConsent,
  getPaymentLimitedPlacesDetails
} from "state/school_money/selectors";
import {
  addPaymentInstallmentToBasket,
  removePaymentInstallmentFromBasket
} from "state/school_money/actions";

import AddOrRemoveButton from "components/school_money/AddOrRemoveButton";
import AddToBasketConfirmationModal from "components/school_money/AddToBasketConfirmationModal";

class PaymentBasketButton extends React.Component {

  static defaultProps = {
    canAddToBasket: true
  }

  state = {
    isConfirmationModalOpen: false
  }

  addToBasket = event => {

    event.stopPropagation();

    const { isPendingParentalConsent, limitedPlaces, canAddToBasket, isPaymentInBasket } = this.props;
    if (!canAddToBasket) {
      logger.debug("This item can't be added to the basket, ignoring...")
      return;
    }

    // If payment is already in basket then no need to show limited places pop up again
    if (isPendingParentalConsent || (!isPaymentInBasket && limitedPlaces.enabled)) {
      this.setState({ isConfirmationModalOpen: true });
    } else {
      this.props.addToBasket();
    }

  }

  removeFromBasket = event => {
    event.stopPropagation();
    this.props.removeFromBasket();
  }

  onModalClose = result => {
    if (result) {
      this.props.addToBasket();
    }
    this.setState({ isConfirmationModalOpen: false });
  }

  render() {
    const { cssBlockName, isInBasket, isPendingParentalConsent, limitedPlaces } = this.props;
    return (
      <React.Fragment>
        <AddToBasketConfirmationModal
          type="payment"
          isOpen={this.state.isConfirmationModalOpen}
          consentRequired={isPendingParentalConsent}
          limitedPlaces={limitedPlaces}
          onClose={this.onModalClose}
        />
        <AddOrRemoveButton
          cssBlockName={cssBlockName}
          isAdded={isInBasket}
          onAdd={this.addToBasket}
          onRemove={this.removeFromBasket}
        />
      </React.Fragment>
    );
  }

}

export default connect(
  (state, { paymentID, installmentNumber }) => ({
    isInBasket: isPaymentInstallmentInBasket(state, paymentID, installmentNumber),
    isPaymentInBasket: isPaymentInBasket(state, paymentID),
    isPendingParentalConsent: isPaymentPendingParentalConsent(state, paymentID),
    limitedPlaces: getPaymentLimitedPlacesDetails(state, paymentID)
  }),
  (dispatch, { paymentID, installmentNumber }) => bindActionCreators({
    addToBasket: () => addPaymentInstallmentToBasket(paymentID, installmentNumber),
    removeFromBasket: () => removePaymentInstallmentFromBasket(paymentID, installmentNumber)
  }, dispatch)
)(PaymentBasketButton);



// WEBPACK FOOTER //
// ./src/components/school_money/payments/PaymentBasketButton.js